"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoundPerCubicFoot = exports.SlugPerCubicFeet = exports.GramPerCubicCentiMeter = exports.KilogramPerCubicMeter = void 0;
var uom_1 = require("uom");
// Density
exports.KilogramPerCubicMeter = uom_1.UnitFormat.createUnitFormat("kg/m³", 2);
exports.GramPerCubicCentiMeter = uom_1.UnitFormat.createUnitFormat("g/cm³", 2);
exports.SlugPerCubicFeet = uom_1.UnitFormat.createUnitFormat("slug/ft³", 3);
exports.PoundPerCubicFoot = uom_1.UnitFormat.createUnitFormat("lb/ft³", 3);
//# sourceMappingURL=density-format.js.map